import React from "react";
import "./BurgerMenu.css";
import { Dropdown, Offcanvas } from "react-bootstrap";
import { Link } from "react-router-dom";

const BurgerMenu = ({ showBurger, setShowBurger }) => {
  const handleClose = () => {
    setShowBurger(false);
  };
  return (
    <Offcanvas
      placement="end"
      scroll={true}
      show={showBurger}
      onHide={handleClose}
      // data-bs-toggle="offcanvas"
      id="eff_nav_toggler"
      class="navbar-toggler"  
      type="button" 
      data-bs-toggle="collapse"  

    >
      <Offcanvas.Header closeButton>
        {/* <Offcanvas.Title>Offcanvas</Offcanvas.Title> */}
      </Offcanvas.Header>
      <Offcanvas.Body>
        <ul className="right-header">
          <li>
            <Link to="/" onClick={handleClose}>صفحه اصلی</Link >
          </li>
          <li>
            <Link  to="/aboutUs" onClick={handleClose}>درباره ما</Link>
          </li>
          <li>
            <Link to="/products" onClick={handleClose}>محصولات</Link>
          </li>
          <li>
            <Link to="/news" onClick={handleClose} >اخبار و مقالات</Link>
          </li>
          <li>
            <Link to="/certificates" onClick={handleClose}>گواهینامه ها</Link>
          </li>
          <li>
            <Link to="/contactUs" onClick={handleClose}>ارتباط با ما</Link>
          </li>
          <Dropdown drop="end">
            <Dropdown.Toggle>امور سهام</Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={handleClose}>بورس</Dropdown.Item>
              <Dropdown.Item onClick={handleClose}>کدال</Dropdown.Item>
              <Dropdown.Item onClick={handleClose}>مدیریت سهامداران</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </ul>
        <div className="button-container">
          <p>سامانه خرید آرد</p>
          <a
            href="https://gfloursale.banksepah.ir/login"
            target="_blank"
            rel="noreferrer"
          >
            Gfloursale.Banksepah.Ir
          </a>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default BurgerMenu;
